export function parse(input) {
  return input.match(/\/(Q\d+)(?:[#?/]|\s*$)/)[1];
}